import {
  ImperativePanelHandle,
  PanelResizeHandle,
} from "react-resizable-panels";
import React from "react";
import { ChevronLeftIcon } from "@heroicons/react/20/solid";
import { classNames } from "@via/utils/helpers.tsx";

export default function PanelResizer({
  panelRef,
  isPanelCollapsed,
}: {
  panelRef: React.MutableRefObject<ImperativePanelHandle | null>;
  isPanelCollapsed: boolean;
}): JSX.Element {
  const handlePanelResizeClick = () => {
    if (panelRef.current) {
      if (panelRef.current.isCollapsed()) {
        panelRef.current?.resize(25);
      } else {
        panelRef.current?.collapse();
      }
    }
  };

  return (
    <PanelResizeHandle className="w-6">
      <div className="relative flex items-start justify-center h-full">
        <div className="absolute top-0 bottom-0 w-[2px] cursor-col-resize bg-gray-200 duration-150 ease-in-out hover:border-r-2 hover:bg-gray-600"></div>
        <div className="mt-5 cursor-pointer relative flex items-center justify-start w-6 h-6 bg-white text-indigo-500 rounded-full shadow-md border border-gray-200 hover:bg-indigo-500 hover:text-white">
          <ChevronLeftIcon
            onClick={() => handlePanelResizeClick()}
            className={classNames(
              isPanelCollapsed ? "rotate-180" : "",
              "w-6 h-6"
            )}
            aria-hidden="true"
          />
        </div>
      </div>
    </PanelResizeHandle>
  );
}
